"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const data_1 = require("../../../data");
const history = (0, graphql_tag_1.default)`
  ${data_1.userPopupSchemaFields}
  ${data_1.documentSchemaFields}
  query polls_history($filtersByType: [PollHistoryEnumGraphQLEnumFilterByType], $pollId: Int) {
    polls {
      history(filtersByType: $filtersByType, pollId: $pollId) {
        id
        date
        historyType
        isRead
        body
        systemText
        fieldName
        template
        newValue
        oldValue
        updater {
          id
          firstName
          lastName
          juristicPersonLegalForm
          juristicPersonName
          personType
          accessLevel
          membership
          role
          showMyAvatar
          avatarColor
          avatarBorderColor
          avatarText
          avatarDisplayName
          avatarUrl
          hasPrivateProfile
          isRegistered
          active
        }
        user {
          ...userPopupSchemaFields
        }
        documents {
          ...documentSchemaFields
        }
        bodyDocuments {
          ...documentSchemaFields
        }
      }
    }
  }
`;
exports.default = history;